<template>
  <input
    id="content-name"
    data-testing="edit-section-name"
    v-model.trim="name"
    :class="[
      'ghost-input',
      { expanded: uiContentStore.isContentSidebarExpanded }
    ]"
    :readonly="!canEditContent"
    @change="saveContentName"
  />
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";

import { SECTION } from "@/constants/assets.constant";
import { showToast } from "@/services/notification-manager";
import { useContentStore } from "@/stores/content.store";
import { useUIContentStore } from "@/stores/ui-content.store";

const contentStore = useContentStore();
const uiContentStore = useUIContentStore();

const props = defineProps({
  contentName: {
    required: true,
    type: String
  },
  sectionId: {
    required: true,
    type: Number
  },
  productId: {
    required: true,
    type: Number
  },
  canEditContent: {
    required: true,
    type: Boolean
  }
});

const name = ref<string>("");
onMounted(() => {
  name.value = props.contentName;
});
watch(
  () => props.contentName,
  newVal => {
    if (newVal) {
      name.value = newVal;
    }
  }
);
const saveContentName = (): void => {
  if (name.value !== "" && name.value !== props.contentName) {
    contentStore
      .upsertSections({
        productIds: [props.productId],
        sections: [
          {
            id: props.sectionId,
            name: name.value
          }
        ]
      })
      .catch(error => {
        showToast({
          message: `${SECTION.ERRORS.nameNotUpdated}: ${error.message}`,
          type: "is-danger"
        });
      });
  }
};
</script>
<style lang="scss" scoped>
.ghost-input {
  &.expanded {
    margin-right: 9rem !important;
  }
}
</style>
